<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" v-if="location=='TTN'">Tân Thuận</h3>
          <h3 class="mb-0" v-if="location=='NTMK'">Nguyễn Thị Minh Khai</h3>
          <h3 class="mb-0" v-if="location=='DBP'">Điện Biên Phủ</h3>
        </div>
        <div class="col-4 text-right">
          <base-checkbox class="mb-3" v-model="autorefesh.checked"  @click="setRefesh">
             Tự cập nhật
          </base-checkbox>
        </div>
        <div class="col text-right">          
          <router-link :to="{path: '/events/add', query:{location:location }}" class="btn btn-sm btn-primary" >Thêm</router-link>
          <router-link :to="{ path: '/events/history'}" class="btn btn-sm btn-info">Lịch Sử</router-link>
        </div>
      </div>
    </div>
    <form class="card-body py-0">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <th>Đơn Vị</th>
          <th>Họ Tên</th>
          <th>Định danh</th>
          <th>T.Khách</th>
          <th>BS.Xe</th>
          <th>Vào</th>
          <th>Ghi Chú</th>
          <th></th>
        </thead>
        
        <tbody>
            <tr v-for="(job, inx) in jobs" :key="inx">
              <th class="p-1" >
                {{ job.orgName}}
              </th>     
              <td class="p-1" >
                {{job.tenant}}
              </td>
              <td class="p-1" >
                {{job.tenantNational}}
              </td>
              <td  class="p-1" width="5%" >

                <base-input input-classes="form-control" class="mb-0">
                        <select v-model.lazy="job.l1Id" >                          
                          <option v-for="the in thecong" :value=the :key="the">{{ the }}</option>
                        </select>
                        </base-input>
              <!--
                <v-select :options="thecong" v-model="job.l1Id" :components="{OpenIndicator}"></v-select>
 
                <base-input placeholder="Thẻ Khách" v-model.lazy="job.l1Id" v-if="job.status!=1"  @focus="setfoc" @blur="setblur" input-classes="form-control-sm" class="mb-0" ></base-input>
                -->
              </td>
              <td   class="p-1" width="12%">
                <base-input placeholder="BS Xe"   v-model.lazy="job.vehicleId" v-if="job.status!=1" input-classes="form-control-sm" class="mb-0" ></base-input>
              </td>
              <td  class="p-1" >
                <base-input>
                    <flat-pickr slot-scope="{focus, blur}"
                      @on-open="focus"
                      @on-close="blur"
                      :config="config"
                      class="form-control-sm datepicker mb-0"
                      v-model="job.in1Date">
                    </flat-pickr>
                  </base-input>
                
              </td>  
              <td class="p-1">
                {{job.notes}}
              </td>
              <td class="text-right p-1"  v-if="job.status==1">
                <base-button type="primary" v-if="permitl3" class="btn-sm" @click="Accept(job)">Xác Nhận</base-button>
                <base-button type="danger" v-if="permitl3" class="btn-sm" @click="modals.modal0 = true">Từ Chối</base-button>
                  <modal :show.sync="modals.modal0">
                  <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Ghi Chú</h5>
                  </template>
                  <div>
                    <base-input class="mb-4">
                        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="ghi chú thêm ..." v-model="job.notes"></textarea>
                      </base-input>
                  </div>
                  <template slot="footer">
                    <base-button type="secondary" @click="modals.modal0 = false">Hủy</base-button>
                    <base-button type="primary" @click="Deny(job)">Lưu</base-button>
                  </template>
                </modal>
              </td>
              <td class="text-right p-1"  v-if="job.status==2">
                <base-button type="primary" class="btn-sm" v-if="permitl1" @click="checkinlayer1(job)">Vào</base-button>
              </td>
              <td class="text-right p-1"  v-if="job.status==3">
                <base-button type="warning" class="btn-sm" v-if="permitl1" @click="closejob(job)">Đóng</base-button>
              </td>
            </tr>
        </tbody>
        
      </table>
    </div>
    </form>
  </div>
</template>
<script>
  export default {
    name: 'InitLayer',
    props:{
      location: {
        type: String
      },
      jobs: {
        type: Array
      },
      thecong: {
        type: Array
      },
      autorefesh:{
        type: Object
      }
    },
    data() {
      return {
        modals: {
          modal0: false
        },
        OpenIndicator: {
        render: createElement => createElement('span', {class: {'toggle': true}}),
        },
        config: {
          enableTime:true,
          dateFormat:"d-m-Y H:i",
          time_24hr: true

          }
        }
    },
    methods: {
      Accept(job) {
        let data = {
          jobId: job._id,
          proccessor: this.$store.state.user.username
        }
        job.proccessor = this.$store.state.user.username
        job.status = 2
        job.allowedAt = this.$moment()
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/accept', data)        
      },
      Deny(job) {
        let data = {
          jobId: job._id,
          notes: job.notes,
          proccessor: this.$store.state.user.username
        }
        job.proccessor = this.$store.state.user.username
        job.status = 3
        job.deniedAt = this.$moment()
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/deny', data)
        
      },
      closejob(job) {
        let data = {
          jobId: job._id
        }
        job.status = 9
        job.openning = false
        job.out1Date = this.$moment()
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/close', data )
        
      },
      checkinlayer1(job) {
        let data = {
          jobId: job._id,
          l1Id: job.l1Id,
          vehicleId: job.vehicleId,
          l1Proctor: this.$store.state.user.username,
          in1Date: job.in1Date
        }
        job.status = 4
        job.in1Date = this.$moment(job.in1Date,"DD-MM-YYYY hh:mm")
        job.l1Proctor = this.$store.state.user.username
        if(job.l1Id) {
          let card = { layer: 0, id: job.l1Id}
          this.$emit('deleteThe',card)
        }
        this.$store.dispatch('updatejob', job)
        this.$http.post('/jobs/in/layer1', data)
        
        
      },
      formattime(curdate) {
        if(curdate){
          return this.$moment.tz(curdate,"Asia/Ho_Chi_Minh").format("DD/MM/YYYY HH:mm")
        }
        return ''
      },
      setRefesh() {
        this.$emit('checkRefesh')
      }
    },
    computed: {
       permitl1() {
          return this.$store.getters.permit_l1
        },
        permitl2() {
          return this.$store.getters.permit_l2
        },
        permitl3() {
          return this.$store.getters.permit_l3
        },
    },
    mounted() {

    },
    beforeDestroy() {
    },
  }
</script>
<style>
</style>
